import { render, staticRenderFns } from "./CarbonOverviewEmssionByBuild.vue?vue&type=template&id=45c37b94&scoped=true&"
import script from "./CarbonOverviewEmssionByBuild.vue?vue&type=script&lang=js&"
export * from "./CarbonOverviewEmssionByBuild.vue?vue&type=script&lang=js&"
import style0 from "./CarbonOverviewEmssionByBuild.vue?vue&type=style&index=0&id=45c37b94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c37b94",
  null
  
)

export default component.exports